import { FetchFailureAction, FetchRequestAction, FetchSuccessAction, StrapiActionTypes, StrapiItem } from '../../types/strapiMyTasks';

export const fetchData = (modelName: string, filters?: any, pagination?: { page: number; pageSize: number }): FetchRequestAction => {
  let params: Record<string, any> = {};

  if (pagination) {
    params['pagination[page]'] = pagination.page;
    params['pagination[pageSize]'] = pagination.pageSize;
  }

  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (
        key.startsWith('filters[') ||
        key.startsWith('fields') ||
        key.startsWith('populate') ||
        key.startsWith('sort') ||
        key.startsWith('pagination[')
      ) {
        params[key] = value;
      } else {
        params[`filters[${key}]`] = value;
      }
    });
  }

  return {
    type: StrapiActionTypes.FETCH_REQUEST_MYTASKS,
    payload: {
      modelName,
      params,
      pagination,
    },
  };
};

export const fetchDataSuccessMyTasks = (
  modelName: string,
  data: StrapiItem[],
  pagination?: {
    page: number;
    pageSize: number;
    pageCount: number;
    total: number;
  }
): FetchSuccessAction => ({
  type: StrapiActionTypes.FETCH_SUCCESS_MYTASKS,
  payload: {
    modelName,
    data,
    pagination,
  },
});

export const fetchDataFailureMyTasks = (modelName: string, error: string): FetchFailureAction => ({
  type: StrapiActionTypes.FETCH_FAILURE_MYTASKS,
  payload: {
    modelName,
    error,
  },
});
